export * from './stateFromElement';


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-import-element/esm/main.js
// module id = 2261
// module chunks = 7